import { FC } from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import * as SC from './styled'

export type SkipToMainProps = {
  className?: string
}

const SkipToMain: FC<SkipToMainProps> = ({ className }) => {
  const { t } = useTranslation()
  return (
    <SC.Skip className={cx('skipToMain', className)} href="#main-layout">
      <SC.Text>{t('skip_to_main')}</SC.Text>
    </SC.Skip>
  )
}

export default SkipToMain
